export default "__VITE_ASSET__873a7248__"